// Mock data for Deon Anderson Portfolio

export const portfolioProjects = [
  {
    id: '1',
    title: 'Corporate Brand Animation',
    description: 'Dynamic motion graphics for Fortune 500 company rebrand',
    category: 'Motion Design',
    imageUrl: 'https://images.unsplash.com/photo-1676238560626-45d35b63b38f',
    videoUrl: 'https://vimeo.com/450948334',
    tags: ['2D Animation', 'Motion Graphics', 'Branding']
  },
  {
    id: '2',
    title: 'Product Explainer Video',
    description: '3D animation showcasing SaaS platform features',
    category: 'Animation',
    imageUrl: 'https://images.unsplash.com/photo-1501780392773-287d506245a5',
    videoUrl: '',
    tags: ['3D Animation', 'Explainer', 'Corporate']
  },
  {
    id: '3',
    title: 'Marketing Campaign Edit',
    description: 'High-energy promotional video for clean energy initiative',
    category: 'Video Editing',
    imageUrl: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d',
    videoUrl: '',
    tags: ['Promotional', 'Social Media', 'Marketing']
  },
  {
    id: '4',
    title: 'Brand Photography',
    description: 'Professional lifestyle photography for tech startup',
    category: 'Photography',
    imageUrl: 'https://images.unsplash.com/photo-1532272278764-53cd1fe53f72',
    videoUrl: '',
    tags: ['Brand Photography', 'Lifestyle', 'Corporate']
  },
  {
    id: '5',
    title: 'Event Coverage',
    description: 'American Heart Association annual conference highlights',
    category: 'Photography',
    imageUrl: 'https://images.pexels.com/photos/35298853/pexels-photo-35298853.jpeg',
    videoUrl: '',
    tags: ['Event', 'Corporate', 'Documentary']
  },
  {
    id: '6',
    title: 'Social Media Content',
    description: 'Story-driven edits for multi-platform campaign',
    category: 'Video Editing',
    imageUrl: 'https://images.unsplash.com/photo-1574717025058-2f8737d2e2b7',
    videoUrl: '',
    tags: ['Social Media', 'Short Form', 'Storytelling']
  },
  {
    id: '7',
    title: 'Animated Logo Sequences',
    description: 'Dynamic logo animations for broadcast and digital',
    category: 'Motion Design',
    imageUrl: 'https://images.unsplash.com/photo-1732032506091-6fd57cc3113e',
    videoUrl: '',
    tags: ['Logo Animation', '2D Animation', 'Branding']
  },
  {
    id: '8',
    title: 'Character Animation',
    description: 'Engaging character-driven explainer for education platform',
    category: 'Character Design',
    imageUrl: 'https://images.unsplash.com/photo-1611643378160-39d6dd915b69',
    videoUrl: '',
    tags: ['Character Design', '2D Animation', 'Education']
  },
  {
    id: '9',
    title: 'Brand Mascot Design',
    description: 'Original character design and animation for tech startup',
    category: 'Character Design',
    imageUrl: 'https://images.unsplash.com/photo-1628494391268-c9935bc384d5',
    videoUrl: '',
    tags: ['Character Design', 'Mascot', 'Branding']
  }
];

export const clients = [
  { name: 'CRM Studios', logo: '' },
  { name: "Dillard's", logo: '' },
  { name: 'American Heart Association', logo: '' },
  { name: 'Voz News', logo: '' },
  { name: 'Omnicell', logo: '' },
  { name: 'Tetra Pak', logo: '' },
  { name: 'Michael Kors', logo: '' },
  { name: 'Super Patch', logo: '' },
  { name: 'KFOR', logo: '' },
  { name: 'Petra Industries', logo: '' },
  { name: 'Spikeball', logo: '' },
  { name: 'Ray-Ban', logo: '' },
  { name: 'Salvation Army', logo: '' }
];

export const services = [
  {
    id: 'motion-design',
    title: 'Motion Design & Animation',
    icon: 'Sparkles',
    description: 'Transform your brand story into captivating motion graphics that engage and inspire.',
    features: [
      '2D & 3D animation',
      'Explainer videos',
      'Motion graphics for marketing & branding',
      'Animated infographics',
      'Logo animations'
    ],
    useCases: 'Perfect for product launches, brand storytelling, social media content, and educational videos.'
  },
  {
    id: 'character-design',
    title: 'Character Design',
    icon: 'Users',
    description: 'Bring memorable characters to life with creative design and personality-driven animation.',
    features: [
      'Original character concept and design',
      'Character animation and rigging',
      'Style guide development',
      'Character-driven storytelling',
      'Mascot design for brands'
    ],
    useCases: 'Ideal for educational content, brand mascots, explainer videos, and entertainment projects.'
  },
  {
    id: 'video-editing',
    title: 'Video Editing',
    icon: 'Film',
    description: 'Professional editing that brings clarity, pacing, and emotional impact to your visual stories.',
    features: [
      'Promotional & social content',
      'Corporate & broadcast editing',
      'Story-driven edits with strong pacing',
      'Color grading & audio mixing',
      'Multi-platform optimization'
    ],
    useCases: 'Ideal for marketing campaigns, corporate communications, event highlights, and digital advertising.'
  },
  {
    id: 'photography',
    title: 'Photography',
    icon: 'Camera',
    description: 'Clean, cinematic photography that captures your brand\'s essence with professional precision.',
    features: [
      'Event photography',
      'Corporate headshots',
      'Real estate photography',
      'Family photos',
      'Brand & lifestyle photography',
      'Product photography'
    ],
    useCases: 'Perfect for corporate events, professional profiles, property listings, family memories, brand identity, and marketing materials.'
  }
];

export const testimonials = [
  {
    id: '1',
    name: 'Sarah Mitchell',
    role: 'Marketing Director',
    company: 'TechFlow Inc',
    text: 'Deon delivered exceptional motion graphics that elevated our product launch. Professional, creative, and reliable.',
    rating: 5
  },
  {
    id: '2',
    name: 'James Rodriguez',
    role: 'Creative Lead',
    company: 'Brand Studio',
    text: 'Outstanding animation work! Deon understood our vision and brought it to life with incredible attention to detail.',
    rating: 5
  }
];